import { Component, inject, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { GlobalService } from '../../services/global.service';
import { ListActionButtonsComponent } from '../../components/list-action-buttons/list-action-buttons.component';
import { ConfirmationPopupComponent } from '../../components/confirmation-popup/confirmation-popup.component';
import { ModalComponent } from '../../components/modal/modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { AgGridListComponent } from "../../components/ag-grid-list/ag-grid-list.component";
import { ButtonComponent } from "../../components/button/button.component";
import { HeaderComponent } from "../../components/header/header.component";
import { PluralPipe } from '../../pipes/plural.pipe';
import { SelectInputComponent } from '../../components/select-input/select-input.component';
import { CommonModule } from '@angular/common';
import { DropdownService } from '../../services/dropdown.service';
import { BulkUploadComponent } from '../../components/bulk-upload/bulk-upload.component';
import { SearchInputComponent } from '../../components/search-input/search-input.component';
import { ExamService } from '../../services/exam.service';
import { ValidationService } from '../../services/validation.service';
import { DropdownUploadButtonComponent } from '../../components/dropdown-upload-button/dropdown-upload-button.component';
import { FormService } from '../../services/form.service';

@Component({
  selector: 'app-exam-list-page',
  imports: [HeaderComponent, ButtonComponent, CommonModule, FormsModule, ConfirmationPopupComponent, ModalComponent, PluralPipe, SelectInputComponent, AgGridListComponent, BulkUploadComponent, SearchInputComponent, DropdownUploadButtonComponent],
  templateUrl: './exam-list-page.component.html',
  styleUrl: './exam-list-page.component.css'
})
export class ExamListPageComponent {
  @ViewChild('confirmation_delete_modal') confirmation_delete_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('confirmation_disabled_modal') confirmation_disabled_modal: ConfirmationPopupComponent | undefined;
  @ViewChild('view_modal') view_modal: ModalComponent | undefined;
  @ViewChild('bulk_modal') bulk_modal: any
  page_name = 'Exam';
  params: any = {};
  selected_ids: any = {}
  items: any = [];
  show_menu = false;


  fs = inject(FormService);

  columns: any = [
    { field: 'AcademicYear.name', headerName: 'Academic Year', filter: true, flex: 1, },
    { field: 'University.name', headerName: 'University', filter: true, flex: 1, },
    { field: 'College.name', headerName: 'College', filter: true, flex: 1, },
    { field: 'Level.name', headerName: 'Level', filter: true, flex: 1, },
    { field: 'Program.name', headerName: 'Program', filter: true, flex: 1, },
    { field: 'Stream.name', headerName: 'Stream', filter: true, flex: 1, },
    { field: 'name', headerName: 'Exam Name', filter: true, flex: 1, },
    { field: 'code', headerName: 'Code', filter: true, flex: 1, },
    { headerName: 'Contact', filter: true, flex: 2, cellRenderer: (p: any) => { const contact = p.data?.contact || ''; const email = p.data?.email || ''; if (contact && email) return `<div style="display:flex;flex-direction:column;justify-content:center;padding:6px 0;line-height:1.4;overflow:hidden"><span style="color:#111;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${contact}</span><span style="color:#888;font-size:13px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${email}</span></div>`; return contact || email || '-'; } },
    { headerName: "", sortable: false, cellRenderer: ListActionButtonsComponent, headerClass: 'custom-header-center', cellRendererParams: { actions: this.actions.bind(this) }, editable: false, pinned: 'right', width: 130, minWidth: 130, maxWidth: 130 }
  ];

  bulk_columns_download: any = [
    { column_name: 'Academic Year', type: 'text', return_as: 'AcademicYear.name', download_bind: 'AcademicYear.name' },
    { column_name: 'University', type: 'text', return_as: 'University.name', download_bind: 'University.name' },
    { column_name: 'Level', type: 'text', return_as: 'Level.name', download_bind: 'Level.name' },
    { column_name: 'Program', type: 'text', return_as: 'Program.name', download_bind: 'Program.name' },
    { column_name: 'Exam Name', type: 'text', return_as: 'name' },
    { column_name: 'Code', type: 'text', return_as: 'code' },
    { column_name: 'Contact', type: 'text', return_as: 'contact' },
    { column_name: 'Email', type: 'text', return_as: 'email' },
  ];

  bulk_columns = [
    { column_name: 'Academic Year', type: 'link', linked_list: 'academic_list', return_as: 'academic_year_id', returning_key: 'id', sample_value: '2025-2026' },
    { column_name: 'University', type: 'link', linked_list: 'university_list', return_as: 'university_id', returning_key: 'id', sample_value: 'Test' },
    { column_name: 'College', type: 'link', linked_list: 'college_list', return_as: 'college_id', returning_key: 'id', sample_value: 'Thakur' },
    { column_name: 'Level', type: 'link', linked_list: 'level_list', return_as: 'level_id', returning_key: 'id', sample_value: 'Test Level' },
    { column_name: 'Program', type: 'link', linked_list: 'program_list', return_as: 'program_id', returning_key: 'id', sample_value: 'Python' },
    // { column_name: 'Subject Name', type: 'link', linked_list: 'subject_list', return_as: 'subject_id', returning_key: 'id',sample_value: 'PG' },
    { column_name: 'Stream Name', type: 'link', linked_list: 'stream_list', return_as: 'stream_id', returning_key: 'id', sample_value: 'STREAM' },
    { column_name: 'Credits', type: 'text', return_as: 'credits', sample_value: '5', max_length: this.vs.max_length_credits, skip_validation: true },
    { column_name: 'Exam Name', type: 'text', return_as: 'name', sample_value: 'Data Base Management System', is_unique: true, min_length: 2, max_length: 150, regex: this.vs.name_pattern },
    { column_name: 'Exam Code', type: 'text', return_as: 'code', sample_value: 'DBMS001', min_length: 2, max_length: 10, regex: this.vs.code_pattern },
    { column_name: 'Contact Number', type: 'text', return_as: 'contact', sample_value: '9212948392', skip_validation: true, min_length: 10, max_length: 12 },
    { column_name: 'Email', type: 'text', return_as: 'email', sample_value: 'exam@gmail.com', skip_validation: true },
  ];

  actions(row: any) {
    let actions: any = []
    actions.push({ text: row.is_active ? 'Disable' : 'Enable', shortcut: 'u', color: 'gray', icon: row.is_active ? 'bx bx-block' : 'bx bx-check-circle', function: this.disable.bind(this), permissions: this.gs.user_role_data?.evaluation_management_examinations_disable })
    actions.push({ text: 'View', shortcut: 'u', color: 'sky', icon: 'bx bx-eye', function: this.open_view_modal.bind(this), permissions: this.gs.user_role_data?.evaluation_management_examinations_view })
    actions.push({ text: 'Edit', shortcut: 'u', color: 'sky', icon: 'bx bx-edit', disabled: row.is_active === false, function: this.navigate_to_form.bind(this), permissions: this.gs.user_role_data?.evaluation_management_examinations_update })
    actions.push({ text: 'Delete', shortcut: 'd', color: 'red', icon: 'bx bx-trash', function: this.open_delete_modal.bind(this), permissions: this.gs.user_role_data?.evaluation_management_examinations_delete })
    return actions
  }

  navigate_to_form(item?: any) {
    if (item?.id) {
      this.route.navigate(['/exam/form'], { queryParams: { id: item.id } });
    } else {
      this.route.navigate(['/exam/form']);
    }
  }
  constructor(public gs: GlobalService, public route: Router, public es: ExamService, public ar: ActivatedRoute, public dds: DropdownService, public vs: ValidationService) { }
  async ngOnInit() {
    await this.dds?.get_dropdown_list(['academic-year', 'university', 'college', 'level', 'stream', 'program']);
    this.ar.queryParams.subscribe(async params => {
      this.params = { ...params }
      // Access Level: lock the filters this user cannot change before the first fetch.
      this.gs.apply_access_scope_to_params(this.params);
      await this.get_list(this.params)

    })
  }
  async get_list(filter?: any) {
    try {
      const res = await this.es.get_list(filter);
      this.items = res;
    } catch (error: any) {
      console.error("Error fetching Booking list:", error);
    }
  }

  on_academic_year_change() {
    this.params.university_id = null;
    this.params.level_id = null;
    this.get_list({ ...this.params, page: 1 });
  }

  on_university_change() {
    this.params.level_id = null;
    this.get_list({ ...this.params, page: 1 });
  }

  onFilterChange() {
    this.get_list({ ...this.params, page: 1 });
  }

  download() {
    this.fs.bulk_download(this.es, 'get_list', this.bulk_columns_download, 'Exam', this.params);
  }
  async open_delete_modal(item: any, index: any) {
    this.selected_ids = item;
    this.confirmation_delete_modal?.open();
  }
  async disable(item: any, index: any) {
    this.selected_ids = item;
    this.confirmation_disabled_modal?.open();
  }

  async delete() {
    try {
      let res = await this.es.delete(this.selected_ids.id);
      if (res != undefined) {
        this.gs.toastr_shows_function(res?.message, 'Success', 'success');
      }
      this.selected_ids = {};
      this.confirmation_delete_modal?.close()
      this.dds.invalidate_dropdown_cache('exam');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  async bulk_delete(ids: any[]) {
    for (let id of ids) {
      await this.es.delete(id);
    }
    this.gs.toastr_shows_function('Records deleted successfully', 'Success', 'success');
    this.dds.invalidate_dropdown_cache('exam');
    await this.get_list(this.params);
  }
  async update_country(item: any) {
    try {
      const data = !item;
      await this.es.update(this.selected_ids.id, { is_active: data });
      this.gs.toastr_shows_function('Status has been successfully updated', 'Success', 'success');
      this.confirmation_disabled_modal?.close();
      this.dds.invalidate_dropdown_cache('exam');
      await this.get_list(this.params);
    } catch (error: any) {
      this.gs.toastr_shows_function(error?.error?.message, 'Error', 'error');
    }
  }
  open_view_modal(item: any) {
    this.selected_ids = item || {};
    this.view_modal?.open();
  }

  async bulk_upload(data: any, spinner: any) {
    try {
      const updatedData = data.map((item: any) => ({
        ...item,
        is_active: true
      }));
      await this.gs.bulk_form_submission(updatedData, this.es, this.params, this.get_list.bind(this), this.bulk_modal, spinner)
    } catch (error: any) {
      this.gs.toastr_shows_function(error.error.message, 'Error', 'error');
    }
  }
}
